module.exports = __webpack_public_path__ + "static/media/18_avatar.2a6f9a11.png";